import { Currency } from 'ecosystem'
import { fileSizeValue } from '../utils/fileSize'

export * from './countryCodesWithVariants'

export const DEFAULT_COUNTRY = 'SE'
export const DEFAULT_CURRENCY = Currency.SEK
export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const VAT_RATES = {
  AT: 20.0,
  BE: 21.0,
  BG: 20.0,
  HR: 25.0,
  CY: 19.0,
  CZ: 21.0,
  DK: 25.0,
  EE: 22.0,
  FI: 25.5,
  FR: 20.0,
  GE: 18.0,
  DE: 19.0,
  GR: 24.0,
  HU: 27.0,
  IS: 24.0,
  IE: 23.0,
  IT: 22.0,
  LV: 21.0,
  LT: 21.0,
  LU: 17.0,
  MT: 18.0,
  MD: 20.0,
  NL: 21.0,
  NO: 25.0,
  PL: 23.0,
  PT: 23.0,
  RO: 19.0,
  SK: 23.0,
  SI: 22.0,
  ES: 21.0,
  SE: 25.0,
  CH: 8.1,
  TR: 20.0,
  UA: 20.0,
  GB: 20.0
}
/** @see https://vercel.com/docs/errors/FUNCTION_PAYLOAD_TOO_LARGE */
export const VERCEL_UPLOAD_MAX_SIZE = fileSizeValue(4.5, 'mb')
